import { styled } from '@mui/system'
import SubmitButton from '../../molecules/button/submit-button'

const FormWrapper = styled('div')`
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	${({ theme }) => theme.breakpoints.up('md')} {
		flex-direction: row;
	}
	& .MuiFormControl-root {
		flex: 1 1 100%;
		padding: 0 10px;
		${({ theme }) => theme.breakpoints.up('md')} {
			flex: 1 1 50%;
		}
	}
	& .MuiFormGroup-root {
		flex-wrap: nowrap;
	}
	& .MuiFormControlLabel-root {
		margin-top: 0px;
		margin-bottom: 0;
	}
	& .MuiFormGroup-root {
		height: 60px;
	}
`

const ActionWrapper = styled('div')`
	padding: 0 10px;
	display: flex;
	justify-content: flex-end;
	margin-top: 30px;
	flex: 1 1 100%;
`

const PrivacyWrapper = styled('div')`
	padding: 0 10px;
	margin-top: 0;
	${({ theme }) => theme.breakpoints.up('md')} {
		margin-top: 24px;
	}
	.MuiCheckbox-root {
		padding-top: 10px;
	}
`

const SubmitButtonStyled = styled(SubmitButton)`
	width: 100%;
	${({ theme }) => theme.breakpoints.up('md')} {
		width: auto;
	}
`

export { FormWrapper, ActionWrapper, PrivacyWrapper, SubmitButtonStyled }
